import { CheckIcon } from '@phosphor-icons/react';

const CorrectAnswerBadge = () => (
  <span className="correct-answer-badge">
    <CheckIcon size={14} weight="regular" />
    Bonne réponse
  </span>
);

export default CorrectAnswerBadge;
